import React from 'react';
import ModuleTabs from './ModuleTabs';
import './PageHeader.css';

/* Encabezado estándar de módulo (F2). Orden corregido por Miguel (2026-07-22,
   regla del fold): las acciones viven EN LA FILA DEL TÍTULO (izq: título;
   der: secundarias + primaria) — la fila exclusiva de acciones se eliminó
   porque era un piso entero de aire. La primaria sigue siendo contextual a la
   pestaña activa aunque viva arriba (el caller la cambia con la tab).
   Pisos resultantes: [título+acciones] → [tabs] → (filtros del módulo).
   Sin tarjeta alrededor: texto libre sobre el fondo de la página. */
export default function PageHeader({
  title,
  description = '',
  metadata = null,          // nodo pequeño bajo la descripción (ej. <SyncStatus/>)
  tabs = null,              // props de ModuleTabs: { tabs, active, onChange, variant }
  primaryAction = null,     // nodo (un <Button variant="primary">) — máximo UNO
  secondaryActions = null,  // nodo(s) — hasta 2 visibles; el resto en OverflowMenu
  utilities = null,         // <HeaderUtilities/> — Actualizar → Exportar, SIEMPRE
                            // al extremo derecho, mismo lugar en toda tab (F4.4)
  center = null,            // control GLOBAL de la pantalla al centro de la fila
                            // (ej. ViewToggle mosaico/tabla del POS, a la altura
                            // de las acciones). Opcional — casi ningún módulo lo usa.
  className = '',
}) {
  return (
    <header className={`ui-page-header${className ? ` ${className}` : ''}`}>
      <div className="ui-page-header-top">
        <div className="ui-page-header-copy">
          <h1 className="ui-page-header-title">{title}</h1>
          {description && <p className="ui-page-header-desc">{description}</p>}
          {metadata && <div className="ui-page-header-meta">{metadata}</div>}
        </div>
        {center && <div className="ui-page-header-center">{center}</div>}
        {(primaryAction || secondaryActions || utilities) && (
          <div className="ui-page-header-actions">
            {secondaryActions}
            {primaryAction}
            {utilities}
          </div>
        )}
      </div>

      {tabs && <ModuleTabs {...tabs} />}
    </header>
  );
}
